<template>
  <div class="state-container">
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <div class="img-container">
      <img
        v-if="statusOk"
        class="login-section_logo"
        src="~@/assets/images/banners/sucesso_cadastro.svg"
        alt="Cadastro feito com sucesso"
      />
      <img
        v-else
        class="error-banner"
        src="~@/assets/images/banners/erro_cadastro.svg"
        alt="Erro"
      />
    </div>
    <div class="msg-container">
      <h1>{{ stateTitle }}</h1>
      <p>
        {{ stateText }}<b>{{ boldText }}</b>
      </p>
      <b-button
        class="button button-primary"
        tag="button"
        @click="$emit('action-fn')"
      >
        {{ buttonText }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateResponse',
  data() {
    return {
      isLoading: false,
      isFullPage: true
    }
  },
  props: {
    statusOk: {
      type: Boolean,
      default: false
    },
    stateTitle: {
      type: String,
      default: ''
    },
    stateText: {
      type: String,
      default: ''
    },
    boldText: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/buttons';
.state-container {
  background-color: var(--bg-color-primary);
  margin-top: 1rem;
  max-height: 70vh;
  height: 100%;
  padding: 2.75rem 3.75rem 6.9375rem;
  display: flex;
  justify-content: center;
  .img-container {
    width: 50%;
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .msg-container {
    width: 35%;
    padding-top: 4rem;
    h1 {
      font-size: 2rem;

      font-weight: $font-bold;
      margin-bottom: 2.1875rem;
      color: var(--gray-900);
      line-height: 1;
    }
    p {
      font-size: 1rem;
      color: var(--neutral-color-1);
    }
  }
  .button {
    margin-top: 3.75rem;
    max-width: 100%;
  }
}
@media (max-width: 48rem) {
  .state-container {
    display: block;
    padding: 1rem 1.2rem;
    .img-container {
      width: 100%;
    }
    .msg-container {
      width: 100%;
    }
  }
}
</style>
